import {useMutation} from "react-apollo";
import {RemovePassengerFromFlight} from "../graphql";
import {PaxNode} from "__generated__/graphql/types";

export default function useRemoveFromFlight(paxNode: Pick<PaxNode, '_id' | 'currentCarrierDoc'>){
    const [ mutate, mutationResult ] = useMutation(RemovePassengerFromFlight, {
        variables: {
            paxId: paxNode?._id,
            flightId: paxNode?.currentCarrierDoc?._id
        }
    });

    return {
        remove: () => {
            if (!paxNode){
                return;
            }
            return mutate();
        },
        loading: mutationResult.loading,
        mutationResult
    }
}